import { render, staticRenderFns } from "./app.loader.vue?vue&type=template&id=0be1187c&scoped=true&"
import script from "./app.loader.vue?vue&type=script&lang=js&"
export * from "./app.loader.vue?vue&type=script&lang=js&"
import style0 from "./app.loader.vue?vue&type=style&index=0&id=0be1187c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1187c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
